import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-224d2680"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "id-auth-container" }
const _hoisted_2 = { class: "employee-help-wrapper" }
const _hoisted_3 = ["aria-expanded"]
const _hoisted_4 = { class: "help-text" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "guide-text" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "emphasis" }, "사원증과 상시출입증 뒷면"),
  /*#__PURE__*/_createTextVNode("에서 확인 가능합니다. ")
], -1 /* HOISTED */))
const _hoisted_6 = ["src"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "modal-content" }, "이미 가입된 구성원이 존재합니다.", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Page"], null, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode($setup["NavigationBar"], {
          title: "ID인증",
          overrideOnClickBack: true,
          onOnClickBack: $setup.goToTermsOfUse
        }),
        _createVNode($setup["Form"], {
          class: "form-wrapper",
          "validation-schema": $setup.schema
        }, {
          default: _withCtx(({ meta }) => [
            _createVNode($setup["TextInput"], {
              class: "input-wrapper",
              name: "name",
              placeholder: "이름을 입력하세요",
              disabled: true,
              value: $setup.maskingUsername,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (($setup.maskingUsername) = $event)),
              "aria-label": "이름 입력 (자동 입력됨)",
              "aria-disabled": "true"
            }, null, 8 /* PROPS */, ["value"]),
            _createVNode($setup["ButtonInput"], {
              class: "input-wrapper employee-no",
              name: "loginId",
              placeholder: "사원번호를 입력하세요",
              buttonTitle: "인증요청",
              disabled: !!$setup.employeeNoVerificationSuccessMsg.length,
              value: $setup.loginId,
              "onUpdate:value": [
                _cache[1] || (_cache[1] = ($event: any) => (($setup.loginId) = $event)),
                _cache[2] || (_cache[2] = ($event: any) => ($setup.updateEmployeeNoVerificationErrorMsg('')))
              ],
              errorMessage: $setup.employeeNoVerificationErrorMsg,
              successMessage: $setup.employeeNoVerificationSuccessMsg,
              onOnClickButton: $setup.verifyEmployeeNumber,
              "aria-invalid": !!$setup.employeeNoVerificationErrorMsg
            }, null, 8 /* PROPS */, ["disabled", "value", "errorMessage", "successMessage", "aria-invalid"]),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("button", {
                type: "button",
                class: "employee-help",
                onClick: $setup.toggleShowEmployeeGuide,
                "aria-expanded": $setup.shouldShowEmployeeGuide,
                "aria-controls": "employee-guide"
              }, [
                _createVNode($setup["InlineSvg"], {
                  src: require('@/assets/icons/help_circle.svg'),
                  "aria-hidden": "true"
                }, null, 8 /* PROPS */, ["src"]),
                _createElementVNode("span", _hoisted_4, _toDisplayString($setup.employeeGuideBtnTitle), 1 /* TEXT */)
              ], 8 /* PROPS */, _hoisted_3),
              _withDirectives(_createElementVNode("div", {
                class: "guide-wrapper",
                role: "region",
                "aria-label": "사원번호 확인 가이드",
                onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
              }, [
                _hoisted_5,
                ($setup.verificationGuideImageUrl)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "guide-image",
                      src: $setup.verificationGuideImageUrl,
                      alt: "사원번호 확인 위치 안내 이미지"
                    }, null, 8 /* PROPS */, _hoisted_6))
                  : _createCommentVNode("v-if", true)
              ], 512 /* NEED_PATCH */), [
                [_vShow, $setup.shouldShowEmployeeGuide]
              ])
            ]),
            _createVNode($setup["BaseButton"], {
              class: "base-button",
              title: "ID인증완료",
              disabled: !meta.valid || !$setup.isVerifiedEmployeeNumber,
              onOnClick: $setup.goToSignUp
            }, null, 8 /* PROPS */, ["disabled"])
          ]),
          _: 1 /* STABLE */
        })
      ]),
      ($setup.shouldShowAlreadySignupMemberModal)
        ? (_openBlock(), _createBlock($setup["Modal"], {
            key: 0,
            title: "인증 실패",
            okButtonTitle: "확인",
            onOnClickOkButton: _cache[4] || (_cache[4] = ($event: any) => (
        [$setup.toggleShowAlreadySignupMemberModal(false), $setup.goToLogin()]
      ))
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1 /* STABLE */
          }))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}